import Client from "@/repositories/Client/AxiosClient.js"

const resource = `/api/export/transactions`
export default {
  async download(slug) {
    return Client.get(`${resource}?${slug}`, {
      responseType: "blob",
    })
  },
}
